import { render, staticRenderFns } from "./workInstruction.vue?vue&type=template&id=44b72e62"
import script from "./workInstruction.vue?vue&type=script&lang=js"
export * from "./workInstruction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports